export default __webpack_public_path__ + "static/media/jartube.2a17832b.png";